module.exports = __webpack_public_path__ + "img/full.6419631b.png";